import React from "react";
import { CheckCircle2 } from "lucide-react";
import CTAButton from "./CTAButton";

const ITEMS = [
  "You have strong expertise, but your lead flow is inconsistent.",
  "You post content regularly, but it rarely brings in real clients.",
  "Your business still runs mostly on referrals and word-of-mouth.",
  "Your offer is valuable, but the market doesn't yet see your authority.",
  "You want to use AI in your business, but not sure how to connect it to revenue.",
  "You're tired of manually chasing prospects in DMs and cold outreach.",
];

export default function ThisIsForYou() {
  return (
    <section className="relative z-10 px-4 py-10 md:py-14">
      <div className="max-w-5xl mx-auto">
        <p className="text-center text-[#C4FF3D] uppercase tracking-[0.28em] text-[11px] md:text-xs font-bold mb-3">
          This Is For You If&hellip;
        </p>
        <h2 className="display-font text-center text-3xl md:text-5xl font-extrabold leading-tight mb-4">
          <span className="text-white">You Recognise Yourself In</span>{" "}
          <span className="lime-box">Even Three</span>{" "}
          <span className="text-white">Of These.</span>
        </h2>
        <p className="text-center text-white/65 max-w-2xl mx-auto mb-12">
          If any of these describe your current reality, this workshop was built for someone exactly like you.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {ITEMS.map((t, i) => (
            <div
              key={i}
              className="flex items-start gap-3 p-5 rounded-2xl bg-[#0e1410] border border-[rgba(196,255,61,0.14)] hover:border-[rgba(196,255,61,0.4)] transition"
            >
              <CheckCircle2 className="w-6 h-6 text-[#C4FF3D] shrink-0 mt-0.5" />
              <p className="text-white/88 leading-relaxed">{t}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 flex justify-center">
          <CTAButton source="this_is_for_you" size="lg">
            Yes! I&apos;m Ready To Scale
          </CTAButton>
        </div>
      </div>
    </section>
  );
}
